import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {LicenseInterceptor} from './license/license.interceptor';
import {OAuthInterceptor} from './oauth/oauth.interceptor';

export const httpInterceptorProviders = [
    {provide: HTTP_INTERCEPTORS, useClass: LicenseInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true},
];
